import * as React from "react";
type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & { variant?: "default" | "outline" | "destructive"; full?: boolean };
export const Button = React.forwardRef<HTMLButtonElement, Props>(
  ({ variant = "default", full = false, className = "", ...p }, ref) => {
    const base = "mc-btn"; const map = { default: "mc-btn--primary", outline: "mc-btn--outline", destructive: "mc-btn--danger" }[variant];
    const wide = full ? "mc-btn--full" : "";
    return <button ref={ref} className={`${base} ${map} ${wide} ${className}`} {...p} />;
  }
);
Button.displayName = "Button";
